export const isObligationBatchPreviewResponse = (value) => {
    if (typeof value !== 'object' || value === null)
        return false;
    const result = value;
    return (typeof result.rule?.id === 'string' &&
        /^\d{4}-\d{2}$/.test(result.period ?? '') &&
        Number.isInteger(result.includedCount) &&
        Number.isInteger(result.excludedCount) &&
        typeof result.totalAmount === 'string' &&
        result.writesPerformed === false &&
        Array.isArray(result.rows) &&
        result.rows.every((row) => typeof row.memberId === 'string' &&
            typeof row.slotId === 'string' &&
            typeof row.slotAssignmentId === 'string' &&
            typeof row.included === 'boolean' &&
            typeof row.reason === 'string'));
};
